
import { graphql, type ResultOf } from '@client/shared/graphql';
import { gqlRequest } from '@client/shared/graphql';

export const AddUnavailabilityMutation = graphql(`
  mutation AddUnavailability($listingId: ID!, $start: String!, $end: String!, $reason: String) {
    addUnavailability(listingId: $listingId, start: $start, end: $end, reason: $reason) {
      id
      listingId
      startsAt
      endsAt
      reason
    }
  }
`);

export type AddUnavailabilityData = ResultOf<typeof AddUnavailabilityMutation>;
export type AddedUnavailability = AddUnavailabilityData['addUnavailability'];

export interface AddUnavailabilityVars {
  readonly listingId: string;
  readonly start: string;
  readonly end: string;
  readonly reason?: string | null;
}

export function addUnavailability(
  vars: AddUnavailabilityVars,
  signal?: AbortSignal,
): Promise<AddUnavailabilityData> {
  return gqlRequest(AddUnavailabilityMutation, vars, { signal });
}
